export default "/images/master-finance.svg?44c77014e62ea6d1b96013046fe94a1f";